import { create } from "zustand";

interface PackageToggleState {
  value: boolean;
  toggle: (value: boolean) => void;
}

export const usePackageToggle = create<PackageToggleState>()((set) => ({
  value: false,
  toggle: (value) => set((state) => ({ ...state, value: value })),
}));
